import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  width: "24",
  height: "24",
  viewBox: "0 0 24 24",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [...(_cache[0] || (_cache[0] = [
    _createElementVNode("path", {
      d: "M9.99144 16.7717C9.87481 15.2215 8.58005 14 7 14C5.34315 14 4 15.3431 4 17C4 18.6569 5.34315 20 7 20C8.65685 20 10 18.6569 10 17C10 16.9232 9.99711 16.8471 9.99144 16.7717ZM9.99144 16.7717C11.1308 15.7429 12.8691 15.7428 14.0086 16.7713M14.0086 16.7713C14.0029 16.8468 14 16.9231 14 17C14 18.6569 15.3431 20 17 20C18.6569 20 20 18.6569 20 17C20 15.3431 18.6569 14 17 14C15.4201 14 14.1254 15.2213 14.0086 16.7713Z",
      stroke: "currentColor",
      "stroke-width": "2",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, null, -1),
    _createElementVNode("path", {
      d: "M19 11H21M19 11L18.2453 5.71716C18.1046 4.73186 17.2607 4 16.2654 4H7.73459C6.73929 4 5.89545 4.73186 5.75469 5.71716L5 11M19 11H5M5 11H3",
      stroke: "currentColor",
      "stroke-width": "2",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, null, -1)
  ]))]))
}
export default { render: render }